/* import __COLOCATED_TEMPLATE__ from './error-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();